import LightningIcon from '../../../../../../../assets/svgs/Lightning'

import NewsItem from './NewsItem'
import SeeAllOnChimp from '../SeeAllOnChimp'
import style from './style.module.css'

const SKELETON_ROWS = 3

const NewsBlock = ({ company, news = [], loading = false, error = null, onRetry }) => {
  const list = Array.isArray(news) ? news : []
  const isEmpty = !loading && !error && list.length === 0

  return (
    <div className={style.companyModal_news}>
      <div className={style.companyModal_news_title}>
        <LightningIcon />
        <span>Hot News</span>
      </div>

      <div className={style.companyModal_news_list} aria-busy={loading}>
        {loading &&
          Array.from({ length: SKELETON_ROWS }).map((item, index) => (
            <div
              // Skeletons carry no identity of their own, so the index is the key.
              key={`news-skeleton-${index}`}
              className={style.companyModal_news_skeleton}
              aria-hidden="true"
            >
              <span />
              <span />
              <span />
            </div>
          ))}

        {!loading && error && (
          <div className={style.companyModal_news_message} role="status">
            <span>Could not load news.</span>
            <button
              type="button"
              className={style.companyModal_news_retry}
              onClick={onRetry}
              data-log-action="spotlight_retry_company"
            >
              Retry
            </button>
          </div>
        )}

        {isEmpty && (
          <div className={style.companyModal_news_message}>
            <span>No news yet</span>
          </div>
        )}

        {!loading && !error && list.map((item) => <NewsItem key={item.id} news={item} />)}
      </div>

      {!loading && !error && list.length > 0 && (
        <SeeAllOnChimp companyName={company?.name} label="See all news on Chimp" />
      )}
    </div>
  )
}

export default NewsBlock
